import axios from "axios";
import {
  Country_name,
  Countrydream,
  FAQ_data,
  GET_ALL_STATE,
  getAllBlogs,
  Search_course,
  Subject_Name,
  TestiMonials,
  University_name,
  Videosdata,
} from "./apirouts";
import { API_URL } from "@/Constant";

// export async function getDatas(endpoint) {
//   try {
//     const response = await axios.get(endpoint, {});
//     return response.data;  // Axios automatically parses the JSON response
//   } catch (error) {
//     console.error('Error fetching data:', error);
//   }
// }

export const Base_Url = API_URL;

axios.defaults.baseURL = Base_Url;

export async function postData(endpoint, data) {
  try {
    const response = await axios.post(endpoint, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error posting data:", error);
  }
}

export const CourseNames = async () => {
  try {
    const response = await axios.get(GET_ALL_STATE, {
      headers: { "Content-Type": "application/json" },
    });
    if (response.status === 200) {
      return { res: response.data };
    }
    return response.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    }
    throw error.message;
  }
};

export const SubjectNames = async () => {
  try {
    const response = await axios.get(Subject_Name, {
      headers: { "Content-Type": "application/json" },
    });
    if (response.status === 200) {
      return { res: response.data };
    }
    return response.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    }
    throw error.message;
  }
};

export const getTestiMonials = async () => {
  try {
    const response = await axios.get(TestiMonials, {
      headers: { "Content-Type": "application/json" },
    });

    if (response.status === 200) {
      return { res: response.data };
    }
    return response.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    }
    throw error.message;
  }
};

export const getBlogs = async () => {
  try {
    const response = await axios.get(getAllBlogs, {
      headers: { "Content-Type": "application/json" },
    });

    if (response.status === 200) {
      return { res: response.data };
    }
    return response.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    }
    throw error.message;
  }
};

export const CountryNames = async () => {
  try {
    const response = await axios.get(Country_name, {
      headers: { "Content-Type": "application/json" },
    });
    if (response.status === 200) {
      return { res: response.data };
    }
    return response.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    }
    throw error.message;
  }
};

export const UniversityName = async (data) => {
  try {
    const response = await axios.post(University_name, data, {
      headers: { "Content-Type": "application/json" },
    });
    if (response.status === 200) {
      return { res: response.data };
    }
    return response.data;
  } catch (error) {
    console.error("Error posting data to University API:", error);
    if (error.response) {
      throw error.response.data;
    }
    throw error.message;
  }
};

export const FAQData = async (data) => {
  try {
    const response = await axios.get(FAQ_data, data, {
      headers: { "Content-Type": "application/json" },
    });
    if (response.status === 200) {
      return { res: response.data };
    }
    return response.data;
  } catch (error) {
    console.error("Error posting data to University API:", error);
    if (error.response) {
      throw error.response.data;
    }
    throw error.message;
  }
};

export const getCoursesList = async ({
  name = "",
  subjectid = [],
  studylevel = [],
  country = [],
  size = 12,
  page = 1,
} = {}) => {
  try {
    const body = {};
    if (subjectid?.length) body.subjectid = subjectid;
    if (studylevel?.length) body.studylevel = studylevel;
    if (country?.length) body.country = country;

    const params = new URLSearchParams({ size, page });
    if (name) params.set("q", name);

    const response = await axios.post(
      `${Search_course}?${params.toString()}`,
      body,
      { headers: { "Content-Type": "application/json" } }
    );
    if (response.status === 200) {
      return { res: response.data };
    }
    return response.data;
  } catch (error) {
    if (error.response) throw error.response.data;
    throw error.message;
  }
};

export const SearchCourse = async (data) => {
  try {
    const response = await axios.post(Search_course, data, {
      headers: { "Content-Type": "application/json" },
    });
    if (response.status === 200) {
      return { res: response.data };
    }
    return response.data;
  } catch (error) {
    console.error("Error posting data to University API:", error);
    if (error.response) {
      throw error.response.data;
    }
    throw error.message;
  }
};

export async function getData(endpoint, data) {
  try {
    const response = await axios.get(endpoint, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error posting data:", error);
  }
}

export function formatDate(dateString = new Date()) {
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.toLocaleString("en-US", { month: "short" });

  // Add suffix for day (e.g., 1st, 2nd, 3rd)
  const daySuffix =
    day % 10 === 1 && day !== 11
      ? "st"
      : day % 10 === 2 && day !== 12
        ? "nd"
        : day % 10 === 3 && day !== 13
          ? "rd"
          : "th";

  return `${day}${daySuffix} ${month}`;
}

export function formatTime(timeString = new Date()) {
  const [hour, minute] = timeString.split(":").map(Number);
  const period = hour >= 12 ? "PM" : "AM";
  const formattedHour = hour % 12 || 12; // Convert 0 to 12 for 12-hour format

  return `${formattedHour}:${minute.toString().padStart(2, "0")} ${period}`;
}

// export const FAQData = async (data) => {
//   try {
//     const response = await axios.get(FAQ_data, data, {
//       headers: { "Content-Type": "application/json" },
//     });
//     if (response.status === 200) {
//       return { res: response.data };
//     }
//     return response.data;
//   } catch (error) {
//     console.error('Error posting data to University API:', error);
//     if (error.response) {
//       throw error.response.data;
//     }
//     throw error.message;
//   }
// };

export const ShowVideosData = async (data) => {
  try {
    const response = await axios.get(Videosdata, data, {
      headers: { "Content-Type": "application/json" },
    });
    if (response.status === 200) {
      return { res: response.data };
    }
    return response.data;
  } catch (error) {
    console.error("Error posting data to University API:", error);
    if (error.response) {
      throw error.response.data;
    }
    throw error.message;
  }
};

export const CountryDreamData = async (data) => {
  try {
    const response = await axios.get(Countrydream, data, {
      headers: { "Content-Type": "application/json" },
    });
    if (response.status === 200) {
      return { res: response.data };
    }
    return response.data;
  } catch (error) {
    console.error("Error posting data to University API:", error);
    if (error.response) {
      throw error.response.data;
    }
    throw error.message;
  }
};
